import React, { useContext, useEffect, useState } from 'react'
import '../index.scss'
import { observer } from 'mobx-react'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import { NavigateFunction } from 'react-router'
import CancelUploadModal from '@Components/Navigations/CreateWorkBottomNavs/FileUploadBottomNavBar/CancelUploadModal'
import GoBackModal from '@Components/Navigations/CreateWorkBottomNavs/FileUploadBottomNavBar/GoBackModal'
import RootStore from '@App/stores/root-store'
import SaveToDraftModal from '@Components/Navigations/CreateWorkBottomNavs/FileUploadBottomNavBar/SaveToDraftModal'
import { WorksFromUpload } from '@Entities/work/works-from-upload'
import FileUploadBottomButtons from '@Components/Navigations/CreateWorkBottomNavs/FileUploadBottomNavBar/FileUploadBottomButtons'

interface FileUploadButtonNavBarProps {
    backLink?: string
    nextLink?: string
    currentStep: number
    navigate: NavigateFunction
}

const FileUploadBottomNavBar = (props: FileUploadButtonNavBarProps) => {
    const { backLink, nextLink, currentStep, navigate } = props
    const { rightsholderStore, bulkUploadStore, preloaderStore, popupStore } = useContext<RootStore>(StoresContext)
    const [redirectURL, setRedirectUrl] = useState<string>()
    const [sidebarIsOpen, setSidebarIsOpen] = useState<boolean>(false)
    const [submittedCountWorks, setSubmittedCountWorksState] = useState<number>()
    const [isDraftsSaved, setIsDraftsSaved] = useState<boolean>(false)
    const [bulkUploadReviewModalIsOpen, setBulkUploadReviewModalIsOpen] = useState<boolean>(false)
    const [individualWorkModalIsOpen, setIndividualWorkModalIsOpen] = useState<boolean>(false)

    if (redirectURL) {
        navigate(redirectURL)
    }

    const setSubmittedCountWorks = () => {
        const allWorksFromUpload = bulkUploadStore.allWorksFromUpload

        if (!allWorksFromUpload) {
            return
        }
        setIsDraftsSaved(false)
        setSubmittedCountWorksState(allWorksFromUpload.complete.length)
    }

    const saveDraftsFromPopup = async (isSave: boolean) => {
        const rightsHolderId = rightsholderStore.currentRightsholderId

        if (isSave) {
            await saveAllDrafts(true)
        }

        bulkUploadStore.destroyAllWorksFromUpload()
        setRedirectUrl(Navigation.rightholder.registrationDrafts.root(rightsHolderId))
    }

    const saveAllDrafts = async (errorsOnly = false) => {
        const allWorksFromUpload = bulkUploadStore.allWorksFromUpload
        const rightsHolderId = rightsholderStore.currentRightsholderId

        if (!allWorksFromUpload) {
            return
        }

        if (!('error' in allWorksFromUpload)) {
            return
        } else {
            const draftsToSave: WorksFromUpload = {
                ...allWorksFromUpload,
                saveErrorsOnly: true,
                isComplete: false,
            }

            if (errorsOnly) {
                draftsToSave.all = allWorksFromUpload.error
                draftsToSave.complete = []
            }

            try {
                preloaderStore.openTransparentPreloader(true)
                await bulkUploadStore.saveUploadWorks(rightsHolderId, draftsToSave)
                popupStore.setAlertData('Works saved to draft successfully', false)
                setIsDraftsSaved(true)
            } catch (e) {
                popupStore.setAlertFromError(e)
            } finally {
                preloaderStore.openTransparentPreloader(false)
            }
        }
    }

    useEffect(() => {
        setSubmittedCountWorks()
    }, [bulkUploadStore.allWorksFromUpload?.complete.length])

    return (
        <>
            <CancelUploadModal
                bulkUploadReviewModalIsOpen={bulkUploadReviewModalIsOpen}
                closeBulkUploadReviewModal={() => setBulkUploadReviewModalIsOpen(false)}
            />
            <GoBackModal
                individualWorkModalIsOpen={individualWorkModalIsOpen}
                closeIndividualWorkModal={() => setIndividualWorkModalIsOpen(false)}
                backLink={backLink}
            />
            <div className="next-back-bar-bottom">
                <FileUploadBottomButtons
                    currentStep={currentStep}
                    backLink={backLink}
                    nextLink={nextLink}
                    submittedCountWorks={submittedCountWorks}
                    setIndividualWorkModalIsOpen={setIndividualWorkModalIsOpen}
                    setBulkUploadReviewModalIsOpen={setBulkUploadReviewModalIsOpen}
                    setRedirectUrl={setRedirectUrl}
                    isDraftsSaved={isDraftsSaved}
                    setSidebarIsOpen={setSidebarIsOpen}
                />
                <SaveToDraftModal
                    setSidebarIsOpen={setSidebarIsOpen}
                    saveDraftsFromPopup={saveDraftsFromPopup}
                    sidebarIsOpen={sidebarIsOpen}
                />
            </div>
        </>
    )
}

export default observer(FileUploadBottomNavBar)
